module.exports = __webpack_public_path__ + "img/skirt-detail-bottom.6b945125.jpg";